import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import Card from '..';
import { Enum_Bookmark_Category, ComponentMissionChapters, Maybe, Trait } from '@edwin-group/cj-graphql';
import BookmarkButton from '@/components/Bookmark/BookmarkButton';

export const arrowChapterImg = '/card/arrow-chapter.png';

const ChapterCard = ({
  chapter,
  index,
  totalChapters,
  button,
  trait,
  chapterId,
  showBookmarkIcon,
  onRemoveFromBookmark,
}: {
  chapterId: string;
  chapter: ComponentMissionChapters;
  index: number;
  totalChapters: number;
  button: React.ReactNode;
  trait?: string | Maybe<Trait> | undefined;
  showBookmarkIcon?: boolean;
  onRemoveFromBookmark?: () => void;
}) => {
  return (
    <Card
      titleExtra={`Chapter ${index + 1}/${totalChapters}`}
      key={chapter?.title}
      title={chapter?.title || ''}
      description={chapter?.description || ''}
      arrowImg={arrowChapterImg}
      tags={
        typeof trait !== 'string' && trait ? (
          <DefaultContentTemplateTags type="CHAPTER" traitTags={[trait]} className="!my-0 !mb-2" />
        ) : (
          <DefaultContentTemplateTags type="CHAPTER" tags={[trait || '']} className="!my-0 !mb-2" />
        )
      }
      image={{
        url: chapter?.cover?.url || '',
        alternativeText: chapter?.cover?.alternativeText || '',
      }}
      button={button}
      bookmarkButton={
        showBookmarkIcon ? (
          <BookmarkButton
            relationId={chapterId}
            metadata={chapter}
            category={Enum_Bookmark_Category.Chapter}
            onRemoveFromBookmark={onRemoveFromBookmark}
          />
        ) : null
      }
    />
  );
};

export default ChapterCard;
